module.exports = __webpack_public_path__ + "img/video.35de891f.svg";